import React, { useEffect, useState } from "react";
import { Button, Typography, Box, Grid } from "@mui/material";
import { ArrowLeft2 } from "iconsax-react";
import { useNavigate } from "react-router-dom";
const UnAuthorizedPage = ({ message, sessionTimeout, }) => {
    const navigate = useNavigate();
    const isAuthenticated = true;
    const [, setTimeLeft] = useState(5);
    const onClickHandle = () => {
        if (isAuthenticated) {
            window.history.back();
        }
        else {
            navigate("/event/login");
        }
    };
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prevTime) => prevTime - 1);
        }, 1000);
        const timeout = setTimeout(() => {
            if (isAuthenticated) {
                window.history.back();
            }
            else {
                navigate("/");
            }
        }, 5000);
        return () => {
            clearInterval(timer);
            clearTimeout(timeout);
        };
    }, [isAuthenticated, navigate]);
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { size: 12 },
            React.createElement(Box, { sx: {
                    display: "flex",
                    height: "calc(100svh - 68px)",
                    justifyContent: "center",
                    alignItems: "center",
                    bgcolor: "white",
                } },
                React.createElement(Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        width: "300px",
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                    } },
                    React.createElement(Box, { sx: {
                            width: "300px",
                            height: "300px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            background: `url(/assets/images/image.png) no-repeat center/cover`,
                        } },
                        React.createElement("img", { src: sessionTimeout
                                ? "/assets/images/timer.png"
                                : "/assets/images/disabled.png", width: sessionTimeout ? 64 : 175, height: sessionTimeout ? 64 : 175, alt: "Disabled icon" })),
                    React.createElement(Box, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "32px",
                            alignItems: "center",
                        } },
                        React.createElement(Box, { sx: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                                alignItems: "center",
                                justifyContent: "center",
                            } },
                            React.createElement(Typography, { variant: "h6", sx: {
                                    textAlign: "center",
                                } }, sessionTimeout
                                ? "Session has timed out. Redirecting in "
                                : "Unauthorized access"),
                            React.createElement(Typography, { variant: "subtitle1", color: "textSecondary" }, message)),
                        React.createElement(Button, { variant: "soft", color: "tertiary", startIcon: React.createElement(ArrowLeft2, null), onClick: onClickHandle }, sessionTimeout ? "Go to Log in" : "Go Back")))))));
};
export default UnAuthorizedPage;
